<div class="opa-header">
  <a [routerLink]="['/']">
    <img
      class="logo"
      src="../../../assets/oash-logo-white.svg"
      alt="oash-logo"
    />
  </a>
</div>
